import React, {useEffect} from 'react';
import LabelComponent from '../Components/LabelComponent';

/**
 * @param {[][]} props.component - 2d array  which contains for every row of a form the inside components
 * @param {setState} props.setComponents - hook method that handle components variable 
 * @param {[][]} props.typeFields - 2d array which contains for every row of a form the types of the inside components  
 * @param {setState} props.setTypeFields - hook method that handle typeFields variable
 * @param {number} props.formRowIndex - index of examined row of a form
 * @param {number} props.indexComponent - index of label component inside row with components
 * @param {boolean} props.clickedChangeElement - variable that is used to render label component again
 * @param {method} props.setClickedChangeElement - hook method that handle clickedChangeElement
 * @param {boolean} props.openAlert - state that opens/closes edit form pop up 
 * @returns component that represent label inside a row of a form
 */
const LabelDataComponent = (props) => {

    const {
        components,
        setComponents,
        typeFields,
        setTypeFields,
        formRowIndex,
        indexComponent,
        clickedChangeElement,
        setClickedChangeElement,
        openAlert
    }= props

    const [labelName, setLabelName] = React.useState('Label Name'); // label name

    /**
     * Initializes label name
     * and update them when component inside form data element has been deleted or added
     */
    useEffect( () => {

        setLabelName(components[formRowIndex][indexComponent].labelName);

    },[openAlert, clickedChangeElement])

    // delete label component method
    const deleteComponent = () => {

        const tempComponents = [...components];
        tempComponents[formRowIndex].splice(indexComponent,1);
        setComponents(tempComponents);

        const tempTypeFields = [...typeFields];
        tempTypeFields[formRowIndex].splice(indexComponent,1);
        setTypeFields(tempTypeFields);
        setClickedChangeElement(true); // set clickedChangeElement to true in order to rerender components
    } 


    // update label name
    const handleLabelName = (val) => {
        setLabelName(val.target.value);
        const tempComponents = [...components];
        tempComponents[formRowIndex][indexComponent].labelName = val.target.value;
        setComponents(tempComponents);
    }

    return(
        <LabelComponent
            deleteComponent = {deleteComponent}
            handleLabelName = {handleLabelName}
            labelName = {labelName}
        />
    )

}

export default LabelDataComponent;